// Research publications — factual record only. No fabricated metrics.
export const publications = [
  {
    id: "st-score-ami-2018",
    title:
      "Utility of ST Score on Admission as a Marker for Outcome in Acute Myocardial Infarction in a Resource Constrained Setting",
    journal: "Journal of Mahatma Gandhi Institute of Medical Sciences",
    year: "2018",
    volume: "Vol 23, pp 77–83",
    authors: "Suyash Bhadoriya, et al.",
    role: "Co-author",
    doi: "10.4103/jmgims.jmgims_27_18",
  },
  {
    id: "copd-tb-rehab-2024",
    title:
      "Effectiveness of Integrated Pulmonary Rehabilitation Programs for Patients with Coexisting COPD and Pulmonary Tuberculosis: A One-Year Prospective Study",
    journal: "African Journal of Biomedical Research",
    year: "2024",
    volume: "Vol 27(3s), pp 3375–3378",
    authors: "Dr. Vivek Arora, Dr. Anurag Shukla, Dr. Suyash Bhadoriya",
    role: "Corresponding Author",
    doi: "10.53555/AJBR.v27i3S.2939",
  },
  {
    id: "renal-cirrhosis-2025",
    title:
      "Evaluation of Renal Manifestations in Liver Cirrhosis Patients: An Observational Study",
    journal: "International Journal of Life Sciences, Biotechnology and Pharma Research",
    year: "2025",
    volume: "Vol 14, No 6, June 2025",
    authors:
      "Dr. Vikas Singh Para, Dr. Suyash Bhadoriya, Dr. Srikant Saral, Dr. Sudeep Pathak",
    role: "Co-author",
    doi: "10.69605/ijlbpr_14.6.2025.14",
  },
];

export const doiLink = (doi) => `https://doi.org/${doi}`;
